import { FC, useMemo, useState } from 'react';

type MapProps = {
  latitude: number;
  longitude: number;
  height: number;
  pointClickText?: string;
};

const LeafletMap: FC<MapProps> = ({
  latitude,
  longitude,
  height,
  pointClickText,
}) => {
  const [mapLoading, setMapLoading] = useState(true);

  const html = useMemo(
    () => `
    <!DOCTYPE html>
    <html>
    <head>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <link rel="stylesheet" href="https://unpkg.com/leaflet/dist/leaflet.css"/>
      <style>
        body, html { margin: 0; padding: 0; }
        #map { height: 100vh; width: 100%; }
        .leaflet-control-container { display: none !important; } 
      </style>
    </head>
    <body>
      <div id="map"></div>
      <script src="https://unpkg.com/leaflet/dist/leaflet.js"></script>
      <script>
        var map = L.map('map', {
          zoomControl: false,
          attributionControl: false,
          scrollWheelZoom: false,
          doubleClickZoom: false,
          boxZoom: false,
          keyboard: false,
          tap: false,
          touchZoom: false,
        }).setView([${latitude}, ${longitude}], 18);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '© <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
        }).addTo(map);

        var redIcon = new L.Icon({
          iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
          shadowUrl: 'https://unpkg.com/leaflet/dist/images/marker-shadow.png',
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
          shadowSize: [41, 41],
        });
        
        L.marker([${latitude}, ${longitude}], { icon: redIcon }).addTo(map).bindPopup('${pointClickText}', { closeButton: false });
      </script>
    </body>
    </html>
  `,
    [latitude, longitude, pointClickText]
  );

  const handleLoad = (): void => {
    setMapLoading(false);
  };

  return (
    <div style={{ position: 'relative', height }}>
      {mapLoading && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'rgba(255,255,255,0.8)',
            zIndex: 10,
          }}
        >
          <div className="loader">Loading map...</div>
        </div>
      )}

      <iframe
        title="leaflet-map"
        style={{ height: '100%', width: '100%', border: 'none' }}
        srcDoc={html}
        onLoad={handleLoad}
      />
    </div>
  );
};

export default LeafletMap;
